export const DEFAULT_LIMIT = 25;
export const DEFAULT_OFFSET = 0;
export const DEFAULT_ITEMS_PER_PAGE = 25;
export const DEFAULT_MAX_LIMIT = 1000;
export const PAGINATION_PROPERTIES = {
  pageSizes: [5, 15, 25, 50, 100, 500, 1000],
  layout: 'total, sizes, prev, pager, next, jumper',
};
